import { LocalStorageKey } from 'shared/constants/localStorage'

import { lsGetItem } from './local-storage'

export const checkOrganizationId = (organizationId: number): boolean => {
  const user = lsGetItem(LocalStorageKey.USER)
  if (!user || typeof user.organization_id !== 'number') return false

  return user.organization_id === organizationId
}
